import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const useChangeLocale = () => {
  const router = useRouter();

  const { asPath, query, pathname } = router;

  const changeLocale = useCallback(
    (locale: string) => router.push({ pathname, query }, asPath, { locale: locale.toLowerCase() }),
    [asPath, pathname, query, router]
  );
  return changeLocale;
};
